import { DiscountRepository } from './repositories/discount'
import { DiscountService } from './services/discount'

const discountRepository = new DiscountRepository()

export const discountService = new DiscountService({ discountRepository })

export type { ValidateDiscountCodeDto, RemoveDiscountCodeDto } from './dtos/discount.dto'
